// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("qwc2-icons.woff?afc159ccecfa782b199683fca091c6e3", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "qwc2-icons";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

.icon {
	line-height: 1;
}

.icon:before {
	font-family: qwc2-icons !important;
	font-style: normal;
	font-weight: normal !important;
	vertical-align: top;
}

.icon-zoomout:before {
	content: "\\f101";
}
.icon-zoomin:before {
	content: "\\f102";
}
.icon-zoom:before {
	content: "\\f103";
}
.icon-warning:before {
	content: "\\f104";
}
.icon-up-down-arrow:before {
	content: "\\f105";
}
.icon-unminimize:before {
	content: "\\f106";
}
.icon-unmaximize:before {
	content: "\\f107";
}
.icon-undock:before {
	content: "\\f108";
}
.icon-undock_top:before {
	content: "\\f109";
}
.icon-undock_right:before {
	content: "\\f10a";
}
.icon-undock_left:before {
	content: "\\f10b";
}
.icon-undock_bottom:before {
	content: "\\f10c";
}
.icon-unchecked:before {
	content: "\\f10d";
}
.icon-tristate:before {
	content: "\\f10e";
}
.icon-triangle-up:before {
	content: "\\f10f";
}
.icon-triangle-right:before {
	content: "\\f110";
}
.icon-triangle-left:before {
	content: "\\f111";
}
.icon-triangle-down:before {
	content: "\\f112";
}
.icon-tree_plus:before {
	content: "\\f113";
}
.icon-tree_minus:before {
	content: "\\f114";
}
.icon-trash:before {
	content: "\\f115";
}
.icon-transparency:before {
	content: "\\f116";
}
.icon-transformtool:before {
	content: "\\f117";
}
.icon-tools:before {
	content: "\\f118";
}
.icon-today:before {
	content: "\\f119";
}
.icon-themes:before {
	content: "\\f11a";
}
.icon-text:before {
	content: "\\f11b";
}
.icon-square:before {
	content: "\\f11c";
}
.icon-snap_vertex:before {
	content: "\\f11d";
}
.icon-snap_edge:before {
	content: "\\f11e";
}
.icon-share:before {
	content: "\\f11f";
}
.icon-selectbox:before {
	content: "\\f120";
}
.icon-search:before {
	content: "\\f121";
}
.icon-screenshot:before {
	content: "\\f122";
}
.icon-scale:before {
	content: "\\f123";
}
.icon-save:before {
	content: "\\f124";
}
.icon-routing:before {
	content: "\\f125";
}
.icon-routing-walking:before {
	content: "\\f126";
}
.icon-routing-truck:before {
	content: "\\f127";
}
.icon-routing-tram:before {
	content: "\\f128";
}
.icon-routing-train:before {
	content: "\\f129";
}
.icon-routing-ship:before {
	content: "\\f12a";
}
.icon-routing-car:before {
	content: "\\f12b";
}
.icon-routing-cablecar:before {
	content: "\\f12c";
}
.icon-routing-bus:before {
	content: "\\f12d";
}
.icon-routing-bicycle:before {
	content: "\\f12e";
}
.icon-remove:before {
	content: "\\f12f";
}
.icon-refresh:before {
	content: "\\f130";
}
.icon-rect:before {
	content: "\\f131";
}
.icon-rasterexport:before {
	content: "\\f132";
}
.icon-radio_unchecked:before {
	content: "\\f133";
}
.icon-radio_tristate:before {
	content: "\\f134";
}
.icon-radio_checked:before {
	content: "\\f135";
}
.icon-print:before {
	content: "\\f136";
}
.icon-polygon:before {
	content: "\\f137";
}
.icon-point:before {
	content: "\\f138";
}
.icon-point_buffer:before {
	content: "\\f139";
}
.icon-plus:before {
	content: "\\f13a";
}
.icon-pick:before {
	content: "\\f13b";
}
.icon-pick_region:before {
	content: "\\f13c";
}
.icon-pick_point:before {
	content: "\\f13d";
}
.icon-pen:before {
	content: "\\f13e";
}
.icon-paint:before {
	content: "\\f13f";
}
.icon-open:before {
	content: "\\f140";
}
.icon-open_link:before {
	content: "\\f141";
}
.icon-ok:before {
	content: "\\f142";
}
.icon-numericinput:before {
	content: "\\f143";
}
.icon-nodetool:before {
	content: "\\f144";
}
.icon-new:before {
	content: "\\f145";
}
.icon-nav-start:before {
	content: "\\f146";
}
.icon-nav-right:before {
	content: "\\f147";
}
.icon-nav-left:before {
	content: "\\f148";
}
.icon-nav-end:before {
	content: "\\f149";
}
.icon-minus:before {
	content: "\\f14a";
}
.icon-minus-sign:before {
	content: "\\f14b";
}
.icon-minimize:before {
	content: "\\f14c";
}
.icon-menu-hamburger:before {
	content: "\\f14d";
}
.icon-measure:before {
	content: "\\f14e";
}
.icon-measure_polygon:before {
	content: "\\f14f";
}
.icon-measure_line:before {
	content: "\\f150";
}
.icon-maximize:before {
	content: "\\f151";
}
.icon-logout:before {
	content: "\\f152";
}
.icon-login:before {
	content: "\\f153";
}
.icon-lock:before {
	content: "\\f154";
}
.icon-list-alt:before {
	content: "\\f155";
}
.icon-link:before {
	content: "\\f156";
}
.icon-line:before {
	content: "\\f157";
}
.icon-line_buffer:before {
	content: "\\f158";
}
.icon-layers:before {
	content: "\\f159";
}
.icon-info:before {
	content: "\\f15a";
}
.icon-info-sign:before {
	content: "\\f15b";
}
.icon-import:before {
	content: "\\f15c";
}
.icon-identify_region:before {
	content: "\\f15d";
}
.icon-identify_radius:before {
	content: "\\f15e";
}
.icon-home:before {
	content: "\\f15f";
}
.icon-freehand:before {
	content: "\\f160";
}
.icon-folder-open:before {
	content: "\\f161";
}
.icon-filter:before {
	content: "\\f162";
}
.icon-fill:before {
	content: "\\f163";
}
.icon-featureform:before {
	content: "\\f164";
}
.icon-eye:before {
	content: "\\f165";
}
.icon-export:before {
	content: "\\f166";
}
.icon-expand:before {
	content: "\\f167";
}
.icon-ellipse:before {
	content: "\\f168";
}
.icon-editing:before {
	content: "\\f169";
}
.icon-edited:before {
	content: "\\f16a";
}
.icon-editdraw:before {
	content: "\\f16b";
}
.icon-dxfexport:before {
	content: "\\f16c";
}
.icon-draw:before {
	content: "\\f16d";
}
.icon-dock:before {
	content: "\\f16e";
}
.icon-dock_top:before {
	content: "\\f16f";
}
.icon-dock_right:before {
	content: "\\f170";
}
.icon-dock_left:before {
	content: "\\f171";
}
.icon-dock_bottom:before {
	content: "\\f172";
}
.icon-dataimport:before {
	content: "\\f173";
}
.icon-cyclomedia:before {
	content: "\\f174";
}
.icon-copy:before {
	content: "\\f175";
}
.icon-confirm:before {
	content: "\\f176";
}
.icon-collapse:before {
	content: "\\f177";
}
.icon-cog:before {
	content: "\\f178";
}
.icon-clock:before {
	content: "\\f179";
}
.icon-clear:before {
	content: "\\f17a";
}
.icon-circle:before {
	content: "\\f17b";
}
.icon-chevron-up:before {
	content: "\\f17c";
}
.icon-chevron-right:before {
	content: "\\f17d";
}
.icon-chevron-left:before {
	content: "\\f17e";
}
.icon-chevron-down:before {
	content: "\\f17f";
}
.icon-checked:before {
	content: "\\f180";
}
.icon-catalog:before {
	content: "\\f181";
}
.icon-camera:before {
	content: "\\f182";
}
.icon-buffer:before {
	content: "\\f183";
}
.icon-box:before {
	content: "\\f184";
}
.icon-bookmark:before {
	content: "\\f185";
}
.icon-bglayer:before {
	content: "\\f186";
}
.icon-before:before {
	content: "\\f187";
}
.icon-arrow-up:before {
	content: "\\f188";
}
.icon-arrow-down:before {
	content: "\\f189";
}
.icon-after:before {
	content: "\\f18a";
}
`, "",{"version":3,"sources":["webpack://./icons/build/qwc2-icons.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,2DAA2E;AAC5E;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kCAAkC;CAClC,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["@font-face {\n\tfont-family: \"qwc2-icons\";\n\tsrc: url(\"qwc2-icons.woff?afc159ccecfa782b199683fca091c6e3\") format(\"woff\");\n}\n\n.icon {\n\tline-height: 1;\n}\n\n.icon:before {\n\tfont-family: qwc2-icons !important;\n\tfont-style: normal;\n\tfont-weight: normal !important;\n\tvertical-align: top;\n}\n\n.icon-zoomout:before {\n\tcontent: \"\\f101\";\n}\n.icon-zoomin:before {\n\tcontent: \"\\f102\";\n}\n.icon-zoom:before {\n\tcontent: \"\\f103\";\n}\n.icon-warning:before {\n\tcontent: \"\\f104\";\n}\n.icon-up-down-arrow:before {\n\tcontent: \"\\f105\";\n}\n.icon-unminimize:before {\n\tcontent: \"\\f106\";\n}\n.icon-unmaximize:before {\n\tcontent: \"\\f107\";\n}\n.icon-undock:before {\n\tcontent: \"\\f108\";\n}\n.icon-undock_top:before {\n\tcontent: \"\\f109\";\n}\n.icon-undock_right:before {\n\tcontent: \"\\f10a\";\n}\n.icon-undock_left:before {\n\tcontent: \"\\f10b\";\n}\n.icon-undock_bottom:before {\n\tcontent: \"\\f10c\";\n}\n.icon-unchecked:before {\n\tcontent: \"\\f10d\";\n}\n.icon-tristate:before {\n\tcontent: \"\\f10e\";\n}\n.icon-triangle-up:before {\n\tcontent: \"\\f10f\";\n}\n.icon-triangle-right:before {\n\tcontent: \"\\f110\";\n}\n.icon-triangle-left:before {\n\tcontent: \"\\f111\";\n}\n.icon-triangle-down:before {\n\tcontent: \"\\f112\";\n}\n.icon-tree_plus:before {\n\tcontent: \"\\f113\";\n}\n.icon-tree_minus:before {\n\tcontent: \"\\f114\";\n}\n.icon-trash:before {\n\tcontent: \"\\f115\";\n}\n.icon-transparency:before {\n\tcontent: \"\\f116\";\n}\n.icon-transformtool:before {\n\tcontent: \"\\f117\";\n}\n.icon-tools:before {\n\tcontent: \"\\f118\";\n}\n.icon-today:before {\n\tcontent: \"\\f119\";\n}\n.icon-themes:before {\n\tcontent: \"\\f11a\";\n}\n.icon-text:before {\n\tcontent: \"\\f11b\";\n}\n.icon-square:before {\n\tcontent: \"\\f11c\";\n}\n.icon-snap_vertex:before {\n\tcontent: \"\\f11d\";\n}\n.icon-snap_edge:before {\n\tcontent: \"\\f11e\";\n}\n.icon-share:before {\n\tcontent: \"\\f11f\";\n}\n.icon-selectbox:before {\n\tcontent: \"\\f120\";\n}\n.icon-search:before {\n\tcontent: \"\\f121\";\n}\n.icon-screenshot:before {\n\tcontent: \"\\f122\";\n}\n.icon-scale:before {\n\tcontent: \"\\f123\";\n}\n.icon-save:before {\n\tcontent: \"\\f124\";\n}\n.icon-routing:before {\n\tcontent: \"\\f125\";\n}\n.icon-routing-walking:before {\n\tcontent: \"\\f126\";\n}\n.icon-routing-truck:before {\n\tcontent: \"\\f127\";\n}\n.icon-routing-tram:before {\n\tcontent: \"\\f128\";\n}\n.icon-routing-train:before {\n\tcontent: \"\\f129\";\n}\n.icon-routing-ship:before {\n\tcontent: \"\\f12a\";\n}\n.icon-routing-car:before {\n\tcontent: \"\\f12b\";\n}\n.icon-routing-cablecar:before {\n\tcontent: \"\\f12c\";\n}\n.icon-routing-bus:before {\n\tcontent: \"\\f12d\";\n}\n.icon-routing-bicycle:before {\n\tcontent: \"\\f12e\";\n}\n.icon-remove:before {\n\tcontent: \"\\f12f\";\n}\n.icon-refresh:before {\n\tcontent: \"\\f130\";\n}\n.icon-rect:before {\n\tcontent: \"\\f131\";\n}\n.icon-rasterexport:before {\n\tcontent: \"\\f132\";\n}\n.icon-radio_unchecked:before {\n\tcontent: \"\\f133\";\n}\n.icon-radio_tristate:before {\n\tcontent: \"\\f134\";\n}\n.icon-radio_checked:before {\n\tcontent: \"\\f135\";\n}\n.icon-print:before {\n\tcontent: \"\\f136\";\n}\n.icon-polygon:before {\n\tcontent: \"\\f137\";\n}\n.icon-point:before {\n\tcontent: \"\\f138\";\n}\n.icon-point_buffer:before {\n\tcontent: \"\\f139\";\n}\n.icon-plus:before {\n\tcontent: \"\\f13a\";\n}\n.icon-pick:before {\n\tcontent: \"\\f13b\";\n}\n.icon-pick_region:before {\n\tcontent: \"\\f13c\";\n}\n.icon-pick_point:before {\n\tcontent: \"\\f13d\";\n}\n.icon-pen:before {\n\tcontent: \"\\f13e\";\n}\n.icon-paint:before {\n\tcontent: \"\\f13f\";\n}\n.icon-open:before {\n\tcontent: \"\\f140\";\n}\n.icon-open_link:before {\n\tcontent: \"\\f141\";\n}\n.icon-ok:before {\n\tcontent: \"\\f142\";\n}\n.icon-numericinput:before {\n\tcontent: \"\\f143\";\n}\n.icon-nodetool:before {\n\tcontent: \"\\f144\";\n}\n.icon-new:before {\n\tcontent: \"\\f145\";\n}\n.icon-nav-start:before {\n\tcontent: \"\\f146\";\n}\n.icon-nav-right:before {\n\tcontent: \"\\f147\";\n}\n.icon-nav-left:before {\n\tcontent: \"\\f148\";\n}\n.icon-nav-end:before {\n\tcontent: \"\\f149\";\n}\n.icon-minus:before {\n\tcontent: \"\\f14a\";\n}\n.icon-minus-sign:before {\n\tcontent: \"\\f14b\";\n}\n.icon-minimize:before {\n\tcontent: \"\\f14c\";\n}\n.icon-menu-hamburger:before {\n\tcontent: \"\\f14d\";\n}\n.icon-measure:before {\n\tcontent: \"\\f14e\";\n}\n.icon-measure_polygon:before {\n\tcontent: \"\\f14f\";\n}\n.icon-measure_line:before {\n\tcontent: \"\\f150\";\n}\n.icon-maximize:before {\n\tcontent: \"\\f151\";\n}\n.icon-logout:before {\n\tcontent: \"\\f152\";\n}\n.icon-login:before {\n\tcontent: \"\\f153\";\n}\n.icon-lock:before {\n\tcontent: \"\\f154\";\n}\n.icon-list-alt:before {\n\tcontent: \"\\f155\";\n}\n.icon-link:before {\n\tcontent: \"\\f156\";\n}\n.icon-line:before {\n\tcontent: \"\\f157\";\n}\n.icon-line_buffer:before {\n\tcontent: \"\\f158\";\n}\n.icon-layers:before {\n\tcontent: \"\\f159\";\n}\n.icon-info:before {\n\tcontent: \"\\f15a\";\n}\n.icon-info-sign:before {\n\tcontent: \"\\f15b\";\n}\n.icon-import:before {\n\tcontent: \"\\f15c\";\n}\n.icon-identify_region:before {\n\tcontent: \"\\f15d\";\n}\n.icon-identify_radius:before {\n\tcontent: \"\\f15e\";\n}\n.icon-home:before {\n\tcontent: \"\\f15f\";\n}\n.icon-freehand:before {\n\tcontent: \"\\f160\";\n}\n.icon-folder-open:before {\n\tcontent: \"\\f161\";\n}\n.icon-filter:before {\n\tcontent: \"\\f162\";\n}\n.icon-fill:before {\n\tcontent: \"\\f163\";\n}\n.icon-featureform:before {\n\tcontent: \"\\f164\";\n}\n.icon-eye:before {\n\tcontent: \"\\f165\";\n}\n.icon-export:before {\n\tcontent: \"\\f166\";\n}\n.icon-expand:before {\n\tcontent: \"\\f167\";\n}\n.icon-ellipse:before {\n\tcontent: \"\\f168\";\n}\n.icon-editing:before {\n\tcontent: \"\\f169\";\n}\n.icon-edited:before {\n\tcontent: \"\\f16a\";\n}\n.icon-editdraw:before {\n\tcontent: \"\\f16b\";\n}\n.icon-dxfexport:before {\n\tcontent: \"\\f16c\";\n}\n.icon-draw:before {\n\tcontent: \"\\f16d\";\n}\n.icon-dock:before {\n\tcontent: \"\\f16e\";\n}\n.icon-dock_top:before {\n\tcontent: \"\\f16f\";\n}\n.icon-dock_right:before {\n\tcontent: \"\\f170\";\n}\n.icon-dock_left:before {\n\tcontent: \"\\f171\";\n}\n.icon-dock_bottom:before {\n\tcontent: \"\\f172\";\n}\n.icon-dataimport:before {\n\tcontent: \"\\f173\";\n}\n.icon-cyclomedia:before {\n\tcontent: \"\\f174\";\n}\n.icon-copy:before {\n\tcontent: \"\\f175\";\n}\n.icon-confirm:before {\n\tcontent: \"\\f176\";\n}\n.icon-collapse:before {\n\tcontent: \"\\f177\";\n}\n.icon-cog:before {\n\tcontent: \"\\f178\";\n}\n.icon-clock:before {\n\tcontent: \"\\f179\";\n}\n.icon-clear:before {\n\tcontent: \"\\f17a\";\n}\n.icon-circle:before {\n\tcontent: \"\\f17b\";\n}\n.icon-chevron-up:before {\n\tcontent: \"\\f17c\";\n}\n.icon-chevron-right:before {\n\tcontent: \"\\f17d\";\n}\n.icon-chevron-left:before {\n\tcontent: \"\\f17e\";\n}\n.icon-chevron-down:before {\n\tcontent: \"\\f17f\";\n}\n.icon-checked:before {\n\tcontent: \"\\f180\";\n}\n.icon-catalog:before {\n\tcontent: \"\\f181\";\n}\n.icon-camera:before {\n\tcontent: \"\\f182\";\n}\n.icon-buffer:before {\n\tcontent: \"\\f183\";\n}\n.icon-box:before {\n\tcontent: \"\\f184\";\n}\n.icon-bookmark:before {\n\tcontent: \"\\f185\";\n}\n.icon-bglayer:before {\n\tcontent: \"\\f186\";\n}\n.icon-before:before {\n\tcontent: \"\\f187\";\n}\n.icon-arrow-up:before {\n\tcontent: \"\\f188\";\n}\n.icon-arrow-down:before {\n\tcontent: \"\\f189\";\n}\n.icon-after:before {\n\tcontent: \"\\f18a\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
